import { create } from 'zustand';
import * as api from '../api';
import type { Source } from '../types';
import { useHeadlineStore } from './headlineStore';

interface SettingsState {
  sources: Source[];
  hiddenIds: number[];
  interestText: string;
  classifierRoles: Record<number, 'interest' | 'no-interest' | 'hide'>;
  classifiers: { id: number; name: string }[];
  fetchSources: () => Promise<void>;
  saveSettings: (
    enabledSourceIds: number[],
    interestText: string,
    classifierRoles?: Record<
      number,
      'interest' | 'no-interest' | 'hide' | null
    >,
  ) => Promise<void>;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  sources: [],
  hiddenIds: [],
  interestText: '',
  classifierRoles: {},
  classifiers: [],
  fetchSources: async () => {
    const { sources, hiddenIds, interestText, classifierRoles, classifiers } =
      await api.fetchSources();
    set({ sources, hiddenIds, interestText, classifierRoles, classifiers });
  },
  saveSettings: async (enabledSourceIds, interestText, classifierRoles) => {
    await api.saveSettings(enabledSourceIds, interestText, classifierRoles);
    const {
      sources,
      hiddenIds,
      interestText: newInterestText,
      classifierRoles: newRoles,
      classifiers: newClassifiers,
    } = await api.fetchSources();
    set({
      sources,
      hiddenIds,
      interestText: newInterestText,
      classifierRoles: newRoles,
      classifiers: newClassifiers,
    });

    // Clear stale interest match flags from cached headlines
    const hs = useHeadlineStore.getState();
    const hasRoles = Object.keys(newRoles).length > 0;
    useHeadlineStore.setState({
      unread: hs.unread.map((h) => ({ ...h, interest_match: null })),
      read: hs.read.map((h) => ({ ...h, interest_match: null })),
      interestMode: hasRoles
        ? 'classifiers'
        : newInterestText.trim().length > 0
          ? 'text'
          : null,
    });
  },
}));
